import type { MenuProps } from "antd"
import {
  FileDownIcon,
  FileQuestionIcon,
  FileText,
  Table2,
  TableIcon,
} from "lucide-react"

import { MimeType } from "../../types/mimetype"

const SUPPORTED_ORIGINAL_MIMETYPES = [
  MimeType.XLSX,
  MimeType.XLSM,
  MimeType.CSV,
]

export const canImportAsQuestionnaire = (
  originalMimetype: MimeType,
): boolean => {
  // TODO(mgraczyk): Implement and remove this (replace with true)
  return SUPPORTED_ORIGINAL_MIMETYPES.includes(originalMimetype)
}

export const getDownloadMenuItems = (
  originalMimeType: MimeType,
  downloading?: boolean,
): (NonNullable<MenuProps["items"]>[number] & {
  key: string
})[] => {
  const downloadItems: (NonNullable<MenuProps["items"]>[number] & {
    key: string
  })[] = [
    ...(SUPPORTED_ORIGINAL_MIMETYPES.includes(originalMimeType)
      ? [
          {
            label: "Original",
            key: "original",
            icon: <FileDownIcon size={16} />,
            disabled: downloading,
          },
        ]
      : []),
    {
      label: "Simplified CSV",
      key: "csv",
      icon: <TableIcon size={16} />,
      disabled: downloading,
    },
    {
      label: "Simplified DOCX",
      key: "docx",
      icon: <FileText size={16} />,
      disabled: downloading,
    },
    {
      label: "Simplified XLSX",
      key: "xlsx",
      icon: <Table2 size={16} />,
      disabled: downloading,
    },
    {
      type: "divider",
      key: "divider",
    },
    {
      label: "Original Unanswered",
      key: "original_unanswered",
      icon: <FileQuestionIcon size={16} />,
      disabled: downloading,
    },
  ]

  return downloadItems
}
